module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git2-de3206f3b0052647c81caf90a19737b3.svg";